import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '@uranda/ui';


@Component({
    selector: 'app-button-outline',
    templateUrl: './button-outline.component.html',
    styleUrls: ['./button-outline.component.scss'],
    standalone: false
})
export class ButtonOutlineComponent extends ButtonComponent {
}
